var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPostAlbumOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_187_3056",
    transform: "scale(0.0192308)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_187_3056",
    width: 52,
    height: 52,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAYAAADFeBvrAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEGSURBVHgB7drBDYMwDAVQEzEQG5QN2g3KEiBuvSJYghHoBrABI7SL0NoShwo5QsIXq/x3iRQ3VX4PKbEgAgD4kWiTdV3ny7LkZDO3bTtohaqqbjxkZBBCGJumGbfzqfbhNcyDDJIk6XkYImUJdCcD3qMM43Y+0J9BIO8QyDsE8g6BvEMg7xDIOwTyLo3Mz+t95jBeP8Vqcjn7MDLg5TMBAJyO2peTvhkfu1cy4DbT1HVdr9XKsiz46L6QAR/bT63vF/sfynhBQQa8YRl6rcY/Vs7fb+rLsTcpfT88+niHQN4hkHcI5B0CeYdA3iGQd+foy0nfbH0P4LCdvpncY15kIHskAIA9Xwr4RNC/KQ9BAAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPostAlbumOn);
export default __webpack_public_path__ + "static/media/icon-post-album-on.34fc5874089ef9fccb38fdf92fbf860a.svg";
export { ForwardRef as ReactComponent };